import { useState, useEffect, useRef } from "react";
import { Link } from "@remix-run/react";
import { Button } from "~/components/ui/button";
import { IconMenu2, IconX, IconHome } from "@tabler/icons-react";
import { technologies } from "~/utils/technologies";
import { ThemeToggle } from "~/components/ThemeToggle";

export function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="md:hidden" ref={menuRef}>
      <Button variant="ghost" size="icon" onClick={toggleMenu}>
        {isOpen ? <IconX size={24} /> : <IconMenu2 size={24} />}
      </Button>
      <div
        className={`fixed inset-0 z-50 transition-opacity duration-300 ${
          isOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <button
          className="absolute inset-0 bg-neutral-500 bg-opacity-75"
          onClick={() => setIsOpen(false)}
        />
        <div
          className={`absolute inset-y-0 right-0 max-w-xs w-full bg-white dark:bg-neutral-900 shadow-xl transform transition-transform duration-300 ease-in-out ${
            isOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="h-full flex flex-col pt-4 overflow-y-scroll">
            <div className="px-4 flex items-center justify-between">
              <h2 className="text-lg font-medium text-neutral-900 dark:text-neutral-100">
                Menu
              </h2>
              <button
                onClick={() => setIsOpen(false)}
                className="text-neutral-400 hover:text-neutral-500 dark:text-neutral-300 dark:hover:text-neutral-200"
              >
                <IconX size={24} />
              </button>
            </div>
            <nav className="mt-2 px-4">
              <Link
                to="/"
                className="flex items-center py-2 text-base font-medium text-neutral-600 hover:text-neutral-900 dark:text-neutral-300 dark:hover:text-neutral-100"
                onClick={() => setIsOpen(false)}
              >
                <IconHome className="mr-4" size={20} />
                All
              </Link>
              {technologies.map((tech) => (
                <Link
                  key={tech.name}
                  to={`/cat/${tech.name}/all`}
                  className="flex items-center py-2 text-base font-medium text-neutral-600 hover:text-neutral-900 dark:text-neutral-300 dark:hover:text-neutral-100"
                  onClick={() => setIsOpen(false)}
                >
                  <tech.icon className="mr-4" size={20} />
                  {tech.name.charAt(0).toUpperCase() + tech.name.slice(1)}
                </Link>
              ))}
            </nav>
            <div className="mt-auto px-4 py-2 border-t border-neutral-200 dark:border-neutral-700">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-neutral-600 dark:text-neutral-300">
                  Theme
                </span>
                <ThemeToggle />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
